/* eslint @typescript-eslint/camelcase: 0 */
import { request } from "api";

export type IndexResponse = {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
};

export class Api {
  public static index() {
    return request.get<IndexResponse[]>("/admin/tracking_vendors");
  }
}
